const Pagination = ({ totalItems, itemsPerPage, onPageChange }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1); 
  
    return (
      <div className="flex flex-row items-center justify-center space-x-6 py-2 bg-[#1A2A3A] rounded-2xl w-10 text-white">
        {pages.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange((page - 1) * itemsPerPage, page * itemsPerPage)}
            className="hover:text-[#141414] cursor-pointer hover:bg-indigo-500 duration-300 hover:-translate-y-1 w-3 text-center rounded-lg"
          >
            {page}
          </button>
        ))}
      </div>
    );
  };

export default Pagination;